import { c as _c } from "react/compiler-runtime";
import { RangePropertiesType } from "@website/ui/range/range.types";
import clamp from "lodash-es/clamp";
import { useEffect, useRef } from "react";
export const useRange = properties => {
  const $ = _c(44);
  const {
    value,
    min,
    max,
    id,
    step,
    onChange
  } = properties;
  const isSingle = typeof value === "number";
  const rangeReference = useRef(null);
  const minValue = isSingle ? 0 : value[0];
  const maxValue = isSingle ? 0 : value[1];
  let t0;
  bb0: {
    if (!step) {
      let t1;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
      } else {
        t1 = $[0];
      }
      t0 = t1;
      break bb0;
    }
    let t1;
    if ($[1] !== max || $[2] !== maxValue || $[3] !== minValue || $[4] !== step) {
      t1 = Array.from({
        length: clamp(Math.round(max / step) + 1, 0, 100)
      })?.map((_, index) => ({
        out: index * step < minValue || index * step > maxValue,
        id: index
      }));
      $[1] = max;
      $[2] = maxValue;
      $[3] = minValue;
      $[4] = step;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    const items = t1;
    t0 = items;
  }
  const stepItems = t0;
  let t1;
  if ($[6] !== isSingle || $[7] !== maxValue || $[8] !== onChange) {
    t1 = event => {
      const value_0 = Number(event.target.value);
      if (maxValue > value_0) {
        onChange(isSingle ? maxValue : [value_0, maxValue], "minOnChange");
      }
    };
    $[6] = isSingle;
    $[7] = maxValue;
    $[8] = onChange;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const onMinChange = t1;
  let t2;
  if ($[10] !== isSingle || $[11] !== minValue || $[12] !== onChange) {
    t2 = event_0 => {
      const value_1 = Number(event_0.target.value);
      if (isSingle) {
        onChange(value_1, "maxOnChange");
      } else {
        if (minValue < value_1) {
          onChange([minValue, value_1], "maxOnChange");
        }
      }
    };
    $[10] = isSingle;
    $[11] = minValue;
    $[12] = onChange;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  const onMaxChange = t2;
  let t3;
  if ($[14] !== max || $[15] !== min) {
    t3 = value_2 => Math.round((value_2 - min) / (max - min) * 100);
    $[14] = max;
    $[15] = min;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  const getPercent = t3;
  let t4;
  let t5;
  if ($[17] !== getPercent || $[18] !== maxValue || $[19] !== minValue) {
    t4 = () => {
      const minPercent = getPercent(minValue);
      const maxPercent = getPercent(maxValue);
      if (rangeReference.current) {
        rangeReference.current.style.width = `${maxPercent - minPercent}%`;
        const {
          direction
        } = getComputedStyle(rangeReference.current);
        if (direction === "rtl") {
          rangeReference.current.style.right = `${minPercent}%`;
        } else {
          rangeReference.current.style.left = `${minPercent}%`;
        }
      }
    };
    t5 = [minValue, maxValue, getPercent];
    $[17] = getPercent;
    $[18] = maxValue;
    $[19] = minValue;
    $[20] = t4;
    $[21] = t5;
  } else {
    t4 = $[20];
    t5 = $[21];
  }
  useEffect(t4, t5);
  const t6 = `min_${id}`;
  let t7;
  if ($[22] !== max || $[23] !== min || $[24] !== minValue || $[25] !== onMinChange || $[26] !== step || $[27] !== t6) {
    t7 = {
      id: t6,
      max,
      min,
      step,
      type: "range",
      value: minValue,
      onChange: onMinChange
    };
    $[22] = max;
    $[23] = min;
    $[24] = minValue;
    $[25] = onMinChange;
    $[26] = step;
    $[27] = t6;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  const t8 = `max_${id}`;
  let t9;
  if ($[29] !== max || $[30] !== maxValue || $[31] !== min || $[32] !== onMaxChange || $[33] !== step || $[34] !== t8) {
    t9 = {
      id: t8,
      max,
      min,
      step,
      type: "range",
      value: maxValue,
      onChange: onMaxChange
    };
    $[29] = max;
    $[30] = maxValue;
    $[31] = min;
    $[32] = onMaxChange;
    $[33] = step;
    $[34] = t8;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  let t10;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      ref: rangeReference
    };
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  let t11;
  if ($[37] !== isSingle || $[38] !== maxValue || $[39] !== minValue || $[40] !== stepItems || $[41] !== t7 || $[42] !== t9) {
    t11 = {
      isSingle,
      minValue,
      maxValue,
      stepItems,
      minInputProperties: t7,
      maxInputProperties: t9,
      rangeProperties: t10
    };
    $[37] = isSingle;
    $[38] = maxValue;
    $[39] = minValue;
    $[40] = stepItems;
    $[41] = t7;
    $[42] = t9;
    $[43] = t11;
  } else {
    t11 = $[43];
  }
  return t11;
};